import React from 'react';
import {Platform} from 'react-native';
import {SvgXml} from 'react-native-svg';

import theme from '../../../style/theme';

import {SvgBadgeComponent} from './types';

// This is not the SVG supplied by Wellcomm. This was done from scratch.
const HbTcBadge: SvgBadgeComponent = ({price, text = '',  size = 55}) => {
  const hasText = text.trim().length > 0;
  const textPositionY = size * 0.44;
  const textFontWeight = Platform.OS === 'web' ? 'normal' : '600';
  const textFontSize = size * (text.length > 8 ? 0.15 : 0.2);
  const pricePositionY = hasText ? textPositionY + size * 0.24 : '60%';
  const priceFontWeight = Platform.OS === 'web' ? '500' : '700';
  const priceFontSize = size * 0.24;
  const svgXml = `
<?xml version="1.0" encoding="utf-8"?>
<svg viewBox="0 0 ${size} ${size}" width="${size}px" height="${size}px" xmlns="http://www.w3.org/2000/svg">
  <circle cx="${size/2}" cy="${size/2}" r="${size/2}" style="fill: ${theme.colour.general.highlight};" />
  ${hasText && `<text
    style="fill: #FFFFFF; font-family: GrotaSansRd-Medium, Helvetica Neue, Helvetica, Arial, sans-serif; font-size: ${textFontSize}px; font-weight: ${textFontWeight};"
    x="50%" y=${textPositionY} text-anchor="middle">${text.toUpperCase()}</text>`
  }
  <text
    style="fill: #FFFFFF; font-family: GrotaSansRd-Medium, Helvetica Neue, Helvetica, Arial, sans-serif; font-size: ${priceFontSize}px; font-weight: ${priceFontWeight};"
    x="50%" y=${pricePositionY} text-anchor="middle">${price}</text>
</svg>
`;
  return <SvgXml xml={svgXml} width="100%" height="100%" />;
};

export default HbTcBadge;
